// load this module if present in DOM

import $ from "jquery";
import plugin from "@core/plugins/lib";
import { onAvailable } from '@core/plugins/lib/selectors';

const ELEMENT_SELECTOR = '[data-paypal-payment]';
const PLUGIN_NAME = 'paypalPayment';

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function(element) {
		System.import(/* webpackChunkName: "paypal-payment" */ './paypal-payment').then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});




// WEBPACK FOOTER //
// ./client/src/core/components/paypal-payment/plugin--available.js